import request from '@/utils/request'

export function fetchList(params) {
    return request({
        url: '/scm/supplier/list',
        method: 'get',
        params: params
    })
}
// 获取供应商详情
export function getSupplierDetail(id) {
    return request({
        url: '/scm/supplier/' + id,
        method: 'get'
    })
}

// 新增供应商
export function addSupplier(data) {
    return request({
        url: '/scm/supplier/create',
		method: 'post',
		data
    })
}

// 编辑供应商
export function updateSupplier(id, data) {
    return request({
        url: '/scm/supplier/update/' + id,
		method: 'post',
		data: data
    })
}



// WEBPACK FOOTER //
// ./src/api/pcm/supplier.js